var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1906 4.28269C16.5938 3.03383 15.2178 2.37221 13.8797 3.0108C12.5416 3.64939 11.9715 5.16381 12.5317 6.49326C12.878 7.31489 13.87 8.91043 14.5774 10.0095C14.8387 10.4155 14.9694 10.6186 15.1603 10.7374C15.324 10.8392 15.5289 10.8942 15.7217 10.8878C15.9463 10.8804 16.161 10.7699 16.5904 10.5489C17.7525 9.95074 19.4094 9.06498 20.1201 8.52655C21.27 7.65535 21.5548 6.05401 20.6939 4.83667C19.833 3.61933 18.3319 3.49955 17.1906 4.28269Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20.7776H8.61029C8.95063 20.7776 9.28888 20.8181 9.61881 20.8991L12.3769 21.5693C12.9753 21.7151 13.5988 21.7293 14.2035 21.6118L17.253 21.0185C18.0585 20.8616 18.7996 20.4759 19.3803 19.9109L21.5379 17.8121C22.154 17.2138 22.154 16.2429 21.5379 15.6435C20.9832 15.1039 20.1047 15.0431 19.4771 15.5007L16.9626 17.3353C16.6025 17.5985 16.1643 17.7403 15.7137 17.7403H13.2855L14.8311 17.7402C15.7022 17.7402 16.4079 17.0538 16.4079 16.2063V15.8996C16.4079 15.1959 15.9156 14.5824 15.2141 14.4123L12.8286 13.8322C12.4404 13.738 12.0428 13.6904 11.6431 13.6904C10.6783 13.6904 8.93189 14.4892 8.93189 14.4892L6 15.7153M2 15.2904L2 21.0904C2 21.6505 2 21.9305 2.10899 22.1444C2.20487 22.3326 2.35785 22.4856 2.54601 22.5814C2.75992 22.6904 3.03995 22.6904 3.6 22.6904H4.4C4.96005 22.6904 5.24008 22.6904 5.45399 22.5814C5.64215 22.4856 5.79513 22.3326 5.89101 22.1444C6 21.9305 6 21.6505 6 21.0904V15.2904C6 14.7304 6 14.4504 5.89101 14.2364C5.79513 14.0483 5.64215 13.8953 5.45399 13.7994C5.24008 13.6904 4.96005 13.6904 4.4 13.6904L3.6 13.6904C3.03995 13.6904 2.75992 13.6904 2.54601 13.7994C2.35785 13.8953 2.20487 14.0483 2.10899 14.2364C2 14.4504 2 14.7304 2 15.2904Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHand);
export default __webpack_public_path__ + "static/media/heart-hand.a76fececb6b281371a8285151c6bb6ab.svg";
export { ForwardRef as ReactComponent };